import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import reviewer from "../../Assets/Projects/reviewer.svg";
import scribe from "../../Assets/Projects/scribe-min.png";
import aba from "../../Assets/Projects/logo-aba-min-dark.png";
import clinic from "../../Assets/Projects/clinic.png";
import sound from "../../Assets/Projects/soundmind.png";
import dl from "../../Assets/Projects/dl.jpeg";
import valdes from "../../Assets/Projects/valdes.png";
import inclusivenest from "../../Assets/Projects/inlcusivenest.png";
import bar from "../../Assets/Projects/bar.png";
import condor from "../../Assets/Projects/condor.png";
import container from "../../Assets/Projects/container.png";
import finnovating from "../../Assets/Projects/finnovating.png";
import ecomerce from "../../Assets/Projects/aionlogo.png";
import ecomerce2 from "../../Assets/Projects/aion-express-horizon.png";
import recargame from "../../Assets/Projects/recargame.PNG";
import boat from "../../Assets/Projects/boat.png";


function Projects() {
    return (
        <Container fluid className="project-section">
            <Particle/>
            <Container>
                <h1 className="project-heading">
                    Recent <strong className="purple">Works </strong>
                </h1>
                <p style={{color: "white"}}>
                    Here are a few projects that we worked on recently.
                </p>
                <Row style={{justifyContent: "center", paddingBottom: "10px"}}>
                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={reviewer}
                            title="NOTE REVIEWER ABA"
                            description="A clinical AI assistant that integrates directly into your browser's side panel, delivering real-time compliance feedback on objectivity, measurability, and ABA regulatory standards without interrupting your documentation flow or altering the source text. Designed to reduce administrative time and minimize costly rework, it empowers behavior analysts to shift their focus from documentation corrections to what truly drives impact: client progress and measurable outcomes."
                            demoLink="https://noterevieweraba.com/"
                            width={100}
                            height={100}
                            tech={'AI Assistant, Browser Extension, and ABA Compliance.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={scribe}
                            title="Scribe10X"
                            description="Revolutionary web-based platform that leverages advanced Artificial Intelligence to democratize and accelerate the process of book creation. It transforms an idea, a rough draft, or a collection of notes into a professionally structured, well-written, and publication-ready manuscript in a fraction of the traditional time. Scribe10X is designed for authors, content creators, marketers, and professionals who want to scale their knowledge and authority through books."
                            demoLink="https://scribe10x.com/en"
                            width={100}
                            height={100}
                            tech={'React.js, NextJs, HeroUI, NextAuth, and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={aba}
                            title="ABA Theraphy documentation"
                            description="Comprehensive, secure, and intuitive web-based platform designed to streamline the documentation process for Applied Behavior Analysis (ABA) therapy providers. By leveraging a modern tech stack, the system empowers Board Certified Behavior Analysts (BCBAs), therapists, and practice administrators to efficiently create, manage, and analyze client progress while ensuring full compliance with industry standards.Build with React.js, NextJs, HeroUI, NextAuth, and Postgrest."
                            demoLink="https://infinitycodellc.com/"
                            width={100}
                            height={100}
                            tech={'React.js, NextJs, HeroUI, NextAuth, Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={clinic}
                            title="Kidney Doctors Dyalisis Center"
                            description="Specialized, secure, and integrated web-based platform designed to streamline the entire operational workflow of a dialysis center. It moves beyond generic clinic software to address the unique clinical, logistical, and regulatory demands of nephrology and dialysis care. The system unifies patient electronic health records (EHR), dialysis treatment tracking, inventory management, and billing into a single, cohesive platform."
                            demoLink="https://www.kidneydoctorsdc.com/index.html"
                            width={250}
                            height={100}
                            tech={'React.js, NextJs, HeroUI, NextAuth, Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={sound}
                            title="Open Sound Mind"
                            description="Innovative and compassionate web-based platform designed to deliver professional music therapy services to children and adults in an accessible, engaging, and personalized manner. We bridge the gap between clients and certified music therapists, creating a safe sonic space for emotional expression, cognitive development, and mental well-being through the power of music."
                            demoLink="https://www.kidneydoctorsdc.com/index.html"
                            width={150}
                            height={100}
                            tech={'React.js, NextJs, HeroUI, NextAuth, Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={inclusivenest}
                            title="InclusiveNest"
                            description="Specialized, secure, and all-in-one web-based platform designed to streamline the entire operational, clinical, and administrative workflow of an Applied Behavior Analysis (ABA) therapy agency. It empowers BCBAs, RBTs, clients, and administrative staff by unifying client management, behavior planning, data collection, billing, and reporting into a single, intuitive, and HIPAA-compliant system."
                            demoLink="https://inclusivenest.com/index.html"
                            width={150}
                            height={100}
                            tech={'React.js, NextJs, HeroUI, NextAuth, Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={recargame}
                            title="Recargame"
                            description="Specialized, secure, and efficient web-based platform designed to streamline the operations of an agency dedicated to providing vital services to the Cuban diaspora. It seamlessly manages two core services: airtime top-ups for Cuban mobile lines and parcel shipping to Cuba, offering a unified solution for customers, agents, and administrators."
                            demoLink="https://www.recargame3d.com/index/?next=%2Fperfil%2F"
                            width={150}
                            height={100}
                            tech={'Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={bar}
                            title="Pedro's Bar"
                            description="Intuitive web-based platform designed to streamline every operation of a modern bar. From order taking and inventory control to staff management and customer analytics, replaces disconnected systems with a unified solution that increases efficiency, reduces costs, and enhances the customer experience."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python, Stripe and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={condor}
                            title="Condor Face"
                            description="Sophisticated, scalable, and secure web-based platform designed to empower businesses, researchers, and data engineers to manage, orchestrate, and monitor a fleet of web scraping bots with military-grade precision. It transforms the complex, often chaotic process of large-scale data extraction into a streamlined, reliable, and data-driven operation."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'React.js, NextJs, MaterialUI, NextAuth, Prisma and MongoDB.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={dl}
                            title="D&L Travel Services"
                            description="Scalable, and user-centric web platform designed to streamline the entire process of parcel shipping for businesses of all sizes, from e-commerce stores to logistics departments. It simplifies comparing rates, printing labels, managing pickups, and tracking shipments—all from a single, unified dashboard."
                            demoLink="https://dnltravelservice.com/"
                            width={150}
                            height={100}
                            tech={'Django, Python and Postgrest.'}
                        />
                    </Col>


                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={valdes}
                            title="Valdes & Sons"
                            description="Scalable, and user-centric web platform designed to streamline the entire process of parcel shipping for businesses of all sizes, from e-commerce stores to logistics departments. It simplifies comparing rates, printing labels, managing pickups, and tracking shipments—all from a single, unified dashboard."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={ecomerce2}
                            title="Aion Express Ecomerce"
                            description="Modern, scalable, and feature-rich e-commerce platform built to deliver a seamless shopping experience from discovery to delivery. Designed for businesses that demand speed, flexibility, and powerful marketing tools, Aion Express combines a lightning-fast storefront with a robust management dashboard to drive sales and foster customer loyalty."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python, Stripe and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={container}
                            title="L&S Containers"
                            description="Advanced, real-time web-based platform designed to provide end-to-end visibility and control over international container shipments. From the moment a container is booked at the port of origin to its final delivery at the destination warehouse. Transforms complex logistics data into actionable insights, enabling shippers, freight forwarders, and supply chain managers to optimize operations, mitigate risks, and ensure timely deliveries."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={boat}
                            title="Private Boat Rental"
                            description="Sophisticated, user-friendly web platform designed to revolutionize the boat rental experience in Miami. Connecting boat owners with tourists and locals seeking aquatic adventures, the system provides a seamless, transparent, and efficient marketplace for discovering, booking, and managing private boat rentals, from luxury yachts to family-friendly pontoon boats."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python, Stripe and Postgrest.'}
                        />
                    </Col>

                    <Col md={4} className="project-card">
                        <ProjectCard
                            imgPath={finnovating}
                            title="Finnovating"
                            description="Powerful, intelligent, and specialized RESTful API service designed to connect top-tier fintech talent with innovative companies. It goes beyond simple job listing aggregation by using sophisticated matching algorithms and industry-specific data to create highly relevant career connections within the fintech ecosystem."
                            offline={true}
                            width={150}
                            height={100}
                            tech={'Django, Python and Postgrest.'}
                        />
                    </Col>

                </Row>
            </Container>
        </Container>
    );
}

export default Projects;
